import { Section, Subject } from '@36node-fcp/core-sdk';
import { concat } from 'lodash';
import { useMemo } from 'react';

import { AdColumnsType, AdTable } from 'src/components/antd/ad-table';
import { ExportModal } from 'src/components/xlsx-export-modal';
import { buildListForSectionReport, SectionReportItem, useSummaryReport } from 'src/features/report';
import { useSlice } from 'src/lib/react-slice';

import { useReportSearch } from './report.context';
import SearchForm from './search.form';

type State = {
  exportVisible: boolean;
};

const initState: State = {
  exportVisible: false,
};
const reducers = {
  openExport(state: State) {
    state.exportVisible = true;
  },
  closeExport(state: State) {
    state.exportVisible = false;
  },
};

/**
 * 路段报表
 */
const SectionReport: React.FC = () => {
  const [{ exportVisible }, dispatch] = useSlice(reducers, initState);
  const [search] = useReportSearch();
  const [{ loading, result }] = useSummaryReport(search);
  const list = useMemo(() => buildListForSectionReport(result), [result]);

  const columns = useMemo<AdColumnsType<SectionReportItem>>(() => {
    const columnsPart1 = [
      {
        title: '路段名',
        dataIndex: 'section',
        compute: (val: Section) => val.name,
      },
    ];
    const columnsPart2 = [
      {
        title: '违法数',
        dataIndex: 'illegalCount',
      },
      {
        title: '预警数',
        dataIndex: 'warningCount',
      },
      {
        title: '查处数',
        dataIndex: 'warningCloseCount',
      },
    ];
    return search.subject.includes(Subject.VEHICLE)
      ? concat(
          columnsPart1,
          [
            {
              title: '过车数',
              dataIndex: 'trackCount',
            },
          ],
          columnsPart2
        )
      : concat(columnsPart1, columnsPart2);
  }, [search]);

  return (
    <>
      <AdTable
        bordered
        columns={columns}
        title={<div>按路段（{list.length}）</div>}
        rowKey="uniqKey"
        loading={loading}
        scroll={{ x: 'max-content' }}
        dataSource={list}
        showColumnsFilter={false}
        pagination={false}
        onExport={dispatch.openExport}
        extraTools={<SearchForm />}
      />
      {exportVisible && (
        <ExportModal
          dataSource={list}
          columns={columns}
          filename="路段报表.xlsx"
          onClose={dispatch.closeExport}
          title="路段报表"
          total={list.length}
        />
      )}
    </>
  );
};

export default SectionReport;
